import React, { Fragment } from 'react';
import { View } from 'react-native';
import StyleSheet from 'react-native-media-query';
import { connect } from 'react-redux';
import lodashIsNumber from 'lodash/isNumber';
import lodashPick from 'lodash/pick';
import { UAParser } from 'ua-parser-js';

import QuantitySelector from '../../Components/QuantitySelector';
import useSchedulePicker from '../../Components/SchedulePicker/index.controller';
import constants from '../../Config/constants';
import CartHelper from '../../Helper/Cart';
import { allCartSelector } from '../../RTK/cart/selectors';
import { whenFilterSelector } from '../../RTK/filter/selectors';
import { updateQuantity } from '../../RTK/product';
import { productSelector } from '../../RTK/product/selectors';
import ThemeStyle from '../../Theme/styles';
import BreakPoints from '../../Theme/styles/breakpoints';

import specialInstructionDefaultValue from './specialInstructionDefaultValue';

function ProductFooter({
  allowZero,
  cartData,
  fill,
  productData,
  stocks,
  dispatchUpdateQuantity,
  ...rest
}) {
  const { setRescheduleStoreId } = useSchedulePicker();
  const { device } = UAParser();

  const existingCartItem = CartHelper?.getCartItem(
    productData?.store?.id,
    productData?.id,
    productData?.extras || [],
    productData?.instructions || specialInstructionDefaultValue,
    cartData,
  );
  const webProps = lodashPick(rest, [
    'disabled',
    'isAddOn',
    'isAvailable',
    'totalPrice',
    'addToCartPress',
  ]);

  const _onQtyChange = (qty) => dispatchUpdateQuantity(qty);
  const isMobileWebView = constants.isWeb && device.type === 'mobile';
  return (
    <Fragment>
      <View style={ThemeStyle.sectionSeparator} />

      <View
        dataSet={{ media: !isMobileWebView && ids.wrapper }}
        style={!isMobileWebView && styles.wrapper}
      >
        <QuantitySelector
          // common props
          allowZero={allowZero}
          fill={fill}
          isUpdate={productData?.isUpdate}
          // limit reached props
          productId={productData?.id}
          storeId={productData?.store?.id}
          stocks={stocks}
          onReschedule={() => setRescheduleStoreId(productData.store.id)}
          // selector props
          value={
            lodashIsNumber(productData?.quantity) ? productData?.quantity : 1
          }
          valueOnCart={existingCartItem?.quantity}
          onChange={_onQtyChange}
          {...webProps}
        />
      </View>
    </Fragment>
  );
}

const { ids, styles } = StyleSheet.create({
  wrapper: {
    ...ThemeStyle.pageHorizontalSpacing,
    ...ThemeStyle.alignItemsCenter,
    ...ThemeStyle.spacingBottomMedium,
    [`@media ${BreakPoints.xs}`]: {
      ...ThemeStyle.spacingTop,
    },
  },
});

const mapStateToProps = (state) => ({
  cartData: allCartSelector(state),
  productData: productSelector(state),
  when: whenFilterSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdateQuantity: (data) => dispatch(updateQuantity(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductFooter);
